import React from 'react';
import { Add } from '@mui/icons-material';
import { MenuItem } from '@mui/material';
import { AddFirmActionProps } from './AddFirmAction.props';

const AddFirmAction = ({ onClickHandler }: AddFirmActionProps) => (
  <MenuItem onClick={onClickHandler}>
    <Add />
    Add Firm
  </MenuItem>
);

export default AddFirmAction;
